import { ZCDetailsViewComponent } from '../../entity-details-view/zc-details-view/zc-details-view.component';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ZoningCode } from 'src/app/modules/instance/models';
import { InstanceService, ZoningCodeService } from 'src/app/modules/instance/services';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import IZoningCode = ZoningAPI.IZoningCode;
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ZCIndexingProcessDetailsViewComponent } from '../../../process-details-view/zc-indexing-process-details-view/zc-indexing-process-details-view.component';

@Component({
    standalone: false,
    selector: 'app-zoning-code-check-status-button',
    templateUrl: './zoning-code-check-status-button.component.html',
    styleUrls: ['./zoning-code-check-status-button.component.scss']
})
export class zoningCodeCheckStatusButtonComponent {
    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        private readonly instanceService: InstanceService,
        private readonly dialog: MatDialog
    ) {}

    private isOpenDialog = false;

    @Input()
    openDialog: boolean;

    @Input()
    isOpen: boolean;

    @Input()
    zoningCode: ZoningCode;

    @Input()
    isLoaded: boolean;

    @Output()
    isLoadedChange = new EventEmitter<boolean>();

    @Output()
    isLoadedDialog = new EventEmitter<boolean>();

    async checkZCStatus(event: Event, zoningCode: ZoningCode) {
        if (this.isOpenDialog) return;

        this.isOpenDialog = true;
        this.isLoadedDialog.emit(true);

        event.stopPropagation();

        if (this.isOpen) {
            this.isLoaded = false;
            this.isLoadedChange.emit(false);
        }

        await this.zoningCodeService.checkZC(zoningCode).toPromise();
        if (!zoningCode.Tasks.length) {
            this.zoningCodeService
                .updateZoningCodeStatus(zoningCode, this.instanceService.selectedInstance.State, {
                    syncSolrData: true,
                    updateZCRecord: true
                })
                .subscribe(() => {
                    /**
                     * TODO :: instead of "ZC Statistic" we should use ZC MetaData
                     */
                    this.zoningCodeService.uploadAndSetZoningCodeStatistic(zoningCode).subscribe(() => {
                        if (this.isOpen) {
                            this.isLoaded = true;
                            this.isLoadedChange.emit(true);
                        }

                        if (this.openDialog) {
                            this.openTaskInfoDialog(zoningCode, ZCDetailsViewComponent);
                        }

                        this.isLoadedDialog.emit(false);
                    });
                });
        } else {
            if (this.isOpen) {
                this.isLoaded = true;
                this.isLoadedChange.emit(true);
            }

            if (this.openDialog) {
                this.openTaskInfoDialog(zoningCode.Tasks[0], ZCIndexingProcessDetailsViewComponent);
            }
            this.isLoadedDialog.emit(false);
        }

        this.instanceService.updateSelectedInstanceStatistic();
    }

    openTaskInfoDialog(tasks: ITaskModel | IZoningCode, component: any) {
        if (!tasks) {
            return;
        }

        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = tasks;
        dialogConfig.maxHeight = '600px';
        dialogConfig.maxWidth = '600px';
        dialogConfig.minWidth = '400px';

        this.dialog.open(component, dialogConfig);
        this.isOpenDialog = false;
    }
}
